import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import cn from 'classnames';
import Icon from 'src/components/HTKit/Icon';
import styles from './styles.scss';

const FlyAwayModal = ({ isVisible, hide, header, children, modalClassName }) => {
  const closeStyles = cn('marginLeft-small', styles.modalClose);
  const slideAnimation = isVisible ? styles.slideUp : styles.slideDown;
  const overlayAnimation = isVisible ? styles.fadein : styles.fadeout;
  const className = cn(styles.modalContainer, slideAnimation, modalClassName);

  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isVisible}
      className={className}
      overlayClassName={cn(overlayAnimation, styles.overlay)}
      contentLabel={header}
      onRequestClose={hide}
    >
      <div className="flex justifyContentSpaceBetween alignItemsCenter">
        <h4>{header}</h4>
        <span onClick={hide}>
          <Icon name="v2-close-icon" className={closeStyles} />
        </span>
      </div>
      <div>{children}</div>
    </ReactModal>
  );
};

FlyAwayModal.propTypes = {
  header: PropTypes.string,
  isVisible: PropTypes.bool,
  hide: PropTypes.func,
  children: PropTypes.node,
  modalClassName: PropTypes.string,
};

FlyAwayModal.defaultProps = {
  isVisible: false,
  modalClassName: '',
};

export default FlyAwayModal;

/*
  * Currently this component assumes the modal to not have content overflowing beyond screen height.
    When design comes back with rendering that shows us how it should look (they were not sure of it as of Sep 7),
    we should update this component styles to add proper positioning.
*/
